export function parseScene() {
    const dataEl = document.getElementById("scene");
    if (dataEl == null) {
        return null;
    }

    return JSON.parse(dataEl.textContent);
}
